export default {
  itemLowStock: {
    id: 'cart_low_stock',
    defaultMessage: 'Only {stock} left',
  },
  tooltip: {
    id: 'cart_low_stock_tooltip',
    defaultMessage: 'Refers to this seller’s stock left at this price.',
  },
}
